import { render, staticRenderFns } from "./create-model.vue?vue&type=template&id=5c1bfe82&"
import script from "./create-model.vue?vue&type=script&lang=ts&"
export * from "./create-model.vue?vue&type=script&lang=ts&"
import style0 from "./create-model.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports